import {
  resolveTimetableProjection,
  resolveTimetableListProjection,
  resolveTimetableContainerProjection,
} from './timetableProjection.js'
import { findRuntimeCatalogCourse, getRuntimeCourseCatalog } from '../services/runtimeCourseCatalog.js'

export {
  resolveTimetableProjection,
  resolveTimetableListProjection,
  resolveTimetableContainerProjection,
}

export function findCatalogCourse(course, catalog = null) {
  return findRuntimeCatalogCourse(course, catalog)
}

export function reconcileCourseClassroom(course = {}, catalog = null) {
  return resolveTimetableProjection(course, catalog)
}

export function reconcileTimetableClassrooms(value = {}, catalog = null) {
  return resolveTimetableContainerProjection(value, catalog)
}

export function reconcileSavedTimetableClassrooms(entries = [], catalog = null) {
  return (Array.isArray(entries) ? entries : []).map(entry => ({
    ...entry,
    ...(Array.isArray(entry?.courses)
      ? { courses: resolveTimetableListProjection(entry.courses, catalog) }
      : {}),
    ...(Array.isArray(entry?.selectedCourses)
      ? { selectedCourses: resolveTimetableListProjection(entry.selectedCourses, catalog) }
      : {}),
  }))
}
